import { Block } from '@shared/models';

export const listingTutosMock: Block<null> = {
  type: 'listing-tutos',
  data: null,
};
